import {
  THREE
} from 'GT3DEngine-module';
// import GT3DBaseView from 'GT3DBaseView-module';
import GT3DBaseView from '@/libs/GT3DBaseView';

export default class GT3DView extends GT3DBaseView {
  constructor(options) {
    super(options)
    if (this.options.autoRotate === undefined)
      this.options.autoRotate = true;
    if (this.options.autoRotate && this.options.autoRotateSpeed === undefined)
      this.options.autoRotateSpeed = 1.0;
    if (this.options.autoRotate && this.options.resetPolarAngleDelta === undefined)
      this.options.resetPolarAngleDelta = 10;
  }

  // onInitialized() {
  //   this.raycaster = new THREE.Raycaster();
  //   this.savedCameraPosition = new THREE.Vector3();

  //   this.sceneStarBlinksScene = new THREE.Scene();
  //   this.sceneStarBlinks = [];
  //   this.sceneStarBlinkPoints = [new THREE.Vector2(-0.2, 0.1)];
  //   let url = 'res/lensflare/star.png';
  //   if (window.location.protocol.match('http')) {
  //     url = this.ensureBaseUrl() + '/editor/' + url;
  //   }
  //   let map = new THREE.TextureLoader().load(url);
  //   this.sceneStarBlinkMaterial = new THREE.MeshBasicMaterial();
  //   this.sceneStarBlinkMaterial.map = map;
  //   this.sceneStarBlinkMaterial.blending = THREE.AdditiveBlending;
  //   this.sceneStarBlinkMaterial.transparent = true;
  //   this.sceneStarBlinkMaterial.depthTest = false;
  //   this.sceneStarBlinkMaterial.needsUpdate = true;
  // }

  initSeat() {
    let url = this.options.url
    if (url === undefined) {
      let baseUrl = this.ensureBaseUrl()
      if (this.options.model) {
        this.options.url = url = baseUrl + '/models/' + this.options.model + '.gt3d'
      }
    }
    return new Promise((resolve, reject) => {
      super.loadScene(url).then((res) => {
        if (res.custom && JSON.stringify(res.custom) !== '{}')
          this.custom = res.custom
        else if (res.result && res.result.userData)
          this.custom = res.result.userData
        if (this.custom) {
          if (this.custom.output) {
            if (this.custom.output.materialChanges)
              this.materialChanges = this.custom.output.materialChanges
            if (this.custom.output.animationGroups)
              this.animationGroups = this.custom.output.animationGroups
          }
        }
        this.initAnimations()
        // this.computeSceneStarBlinkSize()
        // this.gemChecker.checkAndMakeDiamonds(this.scene)
        this.initAutoRotateControls()
        resolve(this.custom)
      }, (error) => {
        reject(error)
      })
    })
  }

  initAutoRotateControls() {
    if (this.options.autoRotate) {
      this.controls.update();
      this.polarAngle = THREE.Math.radToDeg(this.controls.getPolarAngle());
      this.azimuthalAngle = THREE.Math.radToDeg(this.controls.getAzimuthalAngle());
      this.controls.autoRotateSpeed = this.options.autoRotateSpeed;
      this.controls.autoRotate = true;

      this.onMouseDown = this.onMouseDown.bind(this);
      this.onMouseUp = this.onMouseUp.bind(this);

      this.options.element.addEventListener('mousedown', this.onMouseDown, false);
      this.options.element.addEventListener('mouseup', this.onMouseUp, false);
      this.options.element.addEventListener('mouseleave', this.onMouseUp, false);

      this.options.element.addEventListener('touchstart', this.onMouseDown, false);
      this.options.element.addEventListener('touchend', this.onMouseUp, false);
      this.options.element.addEventListener('touchcancel', this.onMouseUp, false);
    }
  }

  onMouseDown(event) {
    this.controls.autoRotate = false;
    this.mouseOrTouchDown = true;
  }

  onMouseUp(event) {
    this.mouseOrTouchDown = false;
    setTimeout(() => {
      this.resetControlsPolarAngleAndAutoRotate();
    }, 1000);
  }

  resetControlsPolarAngleAndAutoRotate() {
    if (this.mouseOrTouchDown || this.isDestroyed)
      return;
    let angle = this.controls.getPolarAngle();
    angle = THREE.Math.radToDeg(angle);
    let offset = this.polarAngle - angle;
    if (Math.abs(offset) > 0.01) {
      let delta;
      if (offset < 0) {
        delta = Math.max(offset, -this.options.resetPolarAngleDelta);
      } else if (offset > 0) {
        delta = Math.min(offset, this.options.resetPolarAngleDelta);
      }
      delta = THREE.Math.degToRad(delta);
      this.controls.sphericalDelta.phi = delta;
      this.controls.update();
      angle = this.controls.getPolarAngle();
      angle = THREE.Math.radToDeg(angle);
      offset = this.polarAngle - angle;
      if (Math.abs(offset) > 0.01) {
        setTimeout(() => {
          this.resetControlsPolarAngleAndAutoRotate();
        }, 50);
      } else {
        this.controls.autoRotate = true;
      }
    } else {
      this.controls.autoRotate = true;
    }
  }

  computeSceneStarBlinkSize() {
    let box = new THREE.Box3();
    box.setFromObject(this.scene);
    let size = box.getSize();
    let max = Math.max(size.x, size.y, size.z);
    console.log('computeSceneStarBlinkSize: ', size, max);
    this.sceneStarBlinkSize = max;
  }

  makeSceneStarBlink(position) {
    let geometry = new THREE.PlaneBufferGeometry(this.sceneStarBlinkSize, this.sceneStarBlinkSize);
    let plane = new THREE.Mesh(geometry, this.sceneStarBlinkMaterial);
    plane.isStartBlink = true;
    plane.position.copy(position);
    plane.lookAt(this.camera.position);
    plane.visible = true;
    this.sceneStarBlinksScene.add(plane);
    return plane;
  }

  updateSceneStarBlink(starBlink, position, object) {
    if (starBlink && starBlink.visible) {
      if (object) {
        while (object.parent && object.parent !== this.scene) {
          object = object.parent;
        }
        let box3 = new THREE.Box3();
        box3.setFromObject(object);
      }
      starBlink.position.copy(position);
      starBlink.lookAt(this.camera.position);
    }
  }

  checkSceneBlinksVisible() {
    if (!this.sceneStarBlinkSize) return;
    for (let i = this.sceneStarBlinkPoints.length - 1; i >= 0; i--) {
      let raycastCoords = this.sceneStarBlinkPoints[i];
      this.raycaster.setFromCamera(raycastCoords, this.camera);
      let intersects = this.raycaster.intersectObjects(this.scene.children, true);
      // console.log(i + ' intersects: ', intersects);
      let intersected = false;
      if (intersects.length > 0) {
        for (let j = 0; j < intersects.length; j++) {
          let object = intersects[j].object;
          if (object.isStartBlink) {
            continue;
          } else {
            if (object.isMetal || object.userData.isMetal) {
              let point = intersects[j].point;
              if (!this.sceneStarBlinks[i]) {
                this.sceneStarBlinks[i] = this.makeSceneStarBlink(point);
                // console.log('makeStarBlink: ', i, raycastCoords, starBlinks[i], intersects[0]);
              }
              this.updateSceneStarBlink(this.sceneStarBlinks[i], point, object);
              this.sceneStarBlinks[i].visible = true;
              intersected = true;
            }
            break;
          }
        }
      }
      if (!intersected) {
        if (this.sceneStarBlinks[i]) {
          this.sceneStarBlinks[i].visible = false;
        }
      }
    }
  }

  // onFrameUpdate() {
  // if (!this.savedCameraPosition.equals(this.camera.position)) {
  //   this.savedCameraPosition.copy(this.camera.position);
  //   this.checkSceneBlinksVisible();
  // }
  // if (this.controls.autoRotate && this.controls.update)
  //   this.controls.update();
  // }

  // render() {
  //   this.renderer.autoClear = false;
  //   super.render();
  //   this.renderer.render(this.sceneStarBlinksScene, this.camera);
  //   this.renderer.autoClear = true;
  // }

  stopPlayingAnimationGroup() {
    if (!this.playingAnimationGroup) {
      console.warn('un finded playingAnimationGroup')
      return
    }
    let animations = this.playingAnimationGroup.animations
    for (let i = 0; i < animations.length; i++) {
      let name = animations[i]
      let action = this.actions[name]
      action.stop()
      action.getMixer().removeAllEventListener('finished')
    }
  }

  playAnimationGroupWithName(name, onFinished) {
    if (!this.animationGroups || this.animationGroups.length === 0) {
      console.warn('the animationGroups is null')
      return false
    }
    if (this.animationIsPlaying) {
      console.warn('other animation is playing')
      return false
    }
    for (let i = this.animationGroups.length - 1; i >= 0; i--) {
      let group = this.animationGroups[i]
      if (group.name === name) {
        this.playingAnimationGroup = group
        this._playAnimationGroup(group, onFinished)
        return true
      }
    }
    console.warn('un finded animationGroup in name:', name)
    return false
  }

  playAnimationGroupWithId(id, onFinished) {
    if (!this.animationGroups || this.animationGroups.length === 0) {
      console.warn('the animationGroups is null')
      return false
    }
    if (this.animationIsPlaying) {
      console.warn('other animation is playing')
      return false
    }
    for (let i = this.animationGroups.length - 1; i >= 0; i--) {
      let group = this.animationGroups[i]
      if (group.id === id) {
        this.playingAnimationGroup = group
        this._playAnimationGroup(group, onFinished)
        return true
      }
    }
    console.warn('un finded animationGroup in name:', name)
    return false
  }

  playAnimationGroupWithIndex(index, onFinished) {
    if (!this.animationGroups || this.animationGroups.length === 0) {
      console.warn('the animationGroups is null')
      return false
    }
    if (this.animationIsPlaying) {
      console.warn('other animation is playing')
      return false
    }
    let group = this.animationGroups[index]
    if (group) {
      this.playingAnimationGroup = group
      this._playAnimationGroup(group, onFinished)
      return true
    }
    console.warn('un finded animationGroup in index:', index)
    return false
  }

  _playAnimationGroup(group, onFinished) {

    let scope = this
    scope.animationIsPlaying = true
    _playNextAnimation(group, 0)

    function _playNextAnimation(group, index) {
      if (index >= group.animations.length) {
        scope.animationIsPlaying = false
        scope.playingAnimationGroup = null;
        if (!group.clampWhenFinished) {
          for (let i = 0; i < group.animations.length; i++) {
            let name = group.animations[i]
            let action = scope.actions[name]
            action.stop()
          }
        }
        console.log('playAnimationGroup finished: ', group)
        if (onFinished)
          onFinished(group)
      } else {
        scope.animationIsPlaying = true
        let name = group.animations[index]
        let action = scope.actions[name]
        let finishedListener = function(event) {
          if (event.action === action) {
            console.log('onFinished: ', event)
            action.getMixer().removeEventListener('finished', finishedListener)
            index++
            _playNextAnimation(group, index)
          }
        }
        action.getMixer().addEventListener('finished', finishedListener)
        action.loop = THREE.LoopOnce
        action.clampWhenFinished = true
        action.stop()
        action.play()
        console.log('playNextAnimation: ', action)
      }
    }
  }

  changeMaterialWithName(name) {
    if (!this.materialChanges || this.materialChanges.length === 0) {
      console.warn('the materialChanges is null')
      return false
    }
    for (let i = this.materialChanges.length - 1; i >= 0; i--) {
      let change = this.materialChanges[i]
      if (change.name === name) {
        this._changeMaterial(change)
        return true
      }
    }
    console.warn('un finded materialChange in name:', name)
    return false
  }

  changeMaterialWithId(id) {
    if (!this.materialChanges || this.materialChanges.length === 0) {
      console.warn('the materialChanges is null')
      return false
    }
    for (let i = this.materialChanges.length - 1; i >= 0; i--) {
      let change = this.materialChanges[i]
      if (change.id === id) {
        this._changeMaterial(change)
        return true
      }
    }
    console.warn('un finded materialChange in name:', name)
    return false
  }

  changeMaterialWithIndex(index) {
    if (!this.materialChanges || this.materialChanges.length === 0) {
      console.warn('the materialChanges is null')
      return true
    }
    let change = this.materialChanges[index]
    if (change) {
      this._changeMaterial(change)
      return true
    }
    console.warn('un finded materialChange in index:', index)
    return false
  }

  _changeMaterial(change) {
    this.loader.loadMaterial(change.material.url, (material) => {
      for (let i = change.nodes.length - 1; i >= 0; i--) {
        let node = change.nodes[i]
        this.scene.traverse((child) => {
          if (child.isMesh && child.name === node.name) {
            if (this.sourceMaterials === undefined)
              this.sourceMaterials = {}
            if (this.sourceMaterials[child.name] === undefined)
              this.sourceMaterials[child.name] = child.material
            child.material = material
          }
        })
      }
    })
  }

  resetMaterial() {
    if (this.sourceMaterials)
      Object.keys(this.sourceMaterials).forEach((key) => {
        this.scene.traverse((child) => {
          if (child.isMesh && child.name === key) {
            child.material = this.sourceMaterials[key]
          }
        })
      })
    this.sourceMaterials = {}
  }

  dispose() {

    if (this.options.autoRotate) {
      this.options.element.removeEventListener('mousedown', this.onMouseDown, false);
      this.options.element.removeEventListener('mouseup', this.onMouseUp, false);
      this.options.element.removeEventListener('mouseleave', this.onMouseUp, false);

      this.options.element.removeEventListener('touchstart', this.onMouseDown, false);
      this.options.element.removeEventListener('touchend', this.onMouseUp, false);
      this.options.element.removeEventListener('touchcancel', this.onMouseUp, false);
    }
    super.dispose();
    this.sourceMaterials = null;
    this.materialChanges = null;
    this.animationGroups = null;
    this.custom = null;

  }
}

// let viewer = new GT3DView({
//   element: document.getElementById('gt3d-content'),
//   baseUrl: 'http://t.p.gemtec.ltd',
//   // model: '4ece9713-3672-40c9-91fa-dbef3bdf6d0d',
//   // model: 'faa4c16a-b9ad-4bb9-9c33-252b7a96e9fb'
//   // model: '2531c4b5-aa4a-4990-a794-57cd40c0438f',
//   // model: '33638ea5-7a3a-4049-94f5-3a271a7ff66c',
//   // model: 'eb381447-52b7-44ee-b929-dfe3b8798757',
//   // model: '3c9547e2-51e5-451c-bc60-a0e5f3e33124',
//   model: 'baf4439b-88c9-4f06-bef1-bd120a3011a2',
// });
// viewer.initSeat();